import {createEvent, type Emitter, type Listener} from "react-event-hook";

export interface CustomHomepageGreetingEventPayload {
    /**
     * The greeting message.
     */
    greetingType: string;
}

interface Event {
    /**
     * Listen for the custom-homepage-greeting event.
     */
    useCustomHomepageGreetingListener: Listener<CustomHomepageGreetingEventPayload>;
    /**
     * Emit the custom-homepage-greeting event.
     *
     * This event is raised by the logged-in homepage to signal that the AI guide
     * should greet the user with an engaging welcome message.
     */
    emitCustomHomepageGreeting: Emitter<CustomHomepageGreetingEventPayload>;
}

export const {useCustomHomepageGreetingListener, emitCustomHomepageGreeting} =
    createEvent("custom-homepage-greeting")() as Event;
